const KEY = 'ili.device';
let cached: string | null = null;

/** Random per-device id, sent as X-Device-Id (rate limits, abuse checks). Not tied to the person. */
export function deviceId(): string {
  if (cached) return cached;
  try {
    cached = localStorage.getItem(KEY);
    if (!cached) {
      cached = crypto.randomUUID();
      localStorage.setItem(KEY, cached);
    }
  } catch {
    cached = cached ?? crypto.randomUUID();
  }
  return cached;
}

export function safeStorage() {
  return {
    get(key: string): string | null {
      try {
        return localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key: string, value: string | null) {
      try {
        if (value === null) localStorage.removeItem(key);
        else localStorage.setItem(key, value);
      } catch {
        /* storage blocked (private mode) */
      }
    },
  };
}
